module.exports = __webpack_public_path__ + "img/imgsure.d2087597.png";